import sectorApi from '@/api/sector.api'

export const sectorService = (function () {
  'use strict'

  /**
   * Obtener todos los sectores relacionados a una empresa
   */
  async function getAllByEnterpriseId(enterpriseId) {
    try {
      const response = await sectorApi.getAllByEnterpriseId(enterpriseId)
      return response.data
    } catch (exception) {
      console.error(exception)
      return false
    }
  }

  /**
   * Obtener todos los sectores relacionados a una empresa y un tipo de equipo
   */
  async function getAllByEnterpriseIdAndTypeId(enterpriseId, typeId) {
    try {
      const response = await sectorApi.getAllByEnterpriseIdAndTypeId(enterpriseId, typeId)
      return response.data
    } catch (exception) {
      console.error(exception)
      return false
    }
  }
  /**
   * valida si el nombre ingresado ya está en uso para la empresa
   * @param {*} name 
   * @param {*} sectors 
   */
  function validateSectorName(name, sectors) {
    name = name.trim().toLowerCase()
    return sectors.find(s => s.name.toLowerCase() === name) ? false : true
  }

  async function canDeleteSector(id) {
    try {
      const response = await sectorApi.canDeleteSector(id)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  return {
    validateSectorName,
    canDeleteSector,
    getAllByEnterpriseId,
    getAllByEnterpriseIdAndTypeId,
  }
})()
